<template>
  <div id="oppreg-wrapper">

    <div class="header">
      <v-container fluid>
        <v-layout
          row
          wrap
          px-2>
          <v-flex
            xs12
            sm8
            md6
            xl6>
            <div v-if="this.$route.query.id || sfdcId" class="headline py-3">Opportunity ID: {{ this.$route.query.id ? this.$route.query.id : sfdcId }}</div>
          </v-flex>
          <v-flex
            xs12
            sm8
            md6
            xl6
            default>
            <v-layout
              column
              align-end>
              <v-flex>
                <v-btn
                  href="/DXC+AWS+Opportunity+Registration+Guide.pdf"
                  target="_blank"
                  class="black--text">Oppreg Instructions</v-btn>
                <!-- <template>
                  <v-dialog
                    v-model="instructionDialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="black--text"
                        v-on="on">Oppreg Instructions</v-btn>
                    </template>
                    <v-card>
                      <v-toolbar
                        dark
                        color="primary">
                        <a href="#">
                          <v-btn
                            icon
                            dark
                            @click="instructionDialog=false">
                            <v-icon>close</v-icon>
                          </v-btn>
                        </a>
                        <v-toolbar-title>Opportunity Registration Instructions</v-toolbar-title>
                      </v-toolbar>
                      <v-container style="margin:25px auto; font-size:14px">
                        <p>The AWS Opportunity Registration process is intended to register DXC opportunities with potential AWS services and products in the solution. If your opportunity has both net-new workloads to be migrated to AWS and existing workloads already on AWS*, ONLY REGISTER THE NET-NEW WORKLOADS via this process. Proceed to "Directions to Register Your Net-New AWS Opportunity" below and follow the steps.  </p>
                        <h3>INSTRUCTIONS TO REGISTER YOUR NET-NEW AWS OPPORTUNITY:</h3>
                        <ol style="margin:15px 0">
                          <li>
                            DXC opportunities with net-new AWS business should be tagged with AWS as an alliance partner and at least one of the following AWS Cloud Services product offerings in SFDC prior to being registered.
                            <ul style="list-style-type:disc; margin:15px 25px;">
                              <li>AWS Private Pricing Agreement (PPA)</li>
                              <li>AWS Solution Provider Program (SPP)</li>
                              <li>Managed Services for AWS</li>
                              <li>Professional Services for AWS</li>
                              <li>QuickStarts - cloud services for AWS</li>
                            </ul>
                          </li>
                          <li> To register your deal, enter the SFDC opportunity ID in the field provided. The page will load with deal information populated from SFDC. (For newly-created SFIDs, please wait 24 hours for the opportunity to be loaded into the Opportunity Registration tool.)</li><br >
                          <li> Populate the additional required fields and press the Submit button.</li>
                          <li> A confirmation message will appear when the opportunity has been successfully registered, and you will receive a registration confirmation email.</li>
                          <li> Upon validation by AWS, you will receive another confirmation email with your AWS Sales Rep contact information, the qualified discount tier, and next steps.</li>
                        </ol>
                      </v-container>
                    </v-card>
                  </v-dialog>
                </template> -->
                <v-btn
                  href="mailto:GuardiansOfTheGalaxy@dxc.com"
                  target="_blank"
                  class="black--text">Contact Galaxy Support</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <formUserOppregLandingForm
      v-if="oppregStep==='verification'"
      :type="'new'"
      @continue="onLandingFormContinue"
    />

    <!-- <div
      v-if="oppregStep==='opportunity'"
      id="register">
      <v-form @submit.prevent="register(sfdcId)">
        <v-container fluid>
          <v-layout
            row
            wrap
            justify-center
            align-top>
            <v-flex
              xs12
              sm12
              md4
              xl4>
              <v-text-field
                v-validate="'required|alpha_dash'"
                :error-messages="errors.collect('sfdcid')"
                v-model.trim="sfdcId"
                data-vv-name="sfdcid"
                solo
                placeholder="DXC SFDC OPPORTUNITY ID:" />
            </v-flex>
            <v-flex
              xs12
              sm12
              md2
              xl2>
              <v-btn
                :loading="registering"
                color="warning"
                @click="register(sfdcId)">Register</v-btn>
            </v-flex>
          </v-layout>
          <v-layout/>
        </v-container>
      </v-form>
    </div> -->

    <!-- OppReg Form Component -->
    <formUserOppregForm v-if="oppregStep==='opportunity'"  @previous= "goBackToVerification"/>
    <!-- Oppreg Workload Questionaire -->
    <formUserOppregWorkload
      v-if="oppregStep==='workload'"
      :sfdc-id="sfdcId"
      :view="'user'"
      @previous= "goBackToOppForm"
      type="new" />
  </div>
</template>

<script>
import { METHODS } from 'http'
import { Validator } from 'vee-validate'
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  // $_veeValidate: { validator: 'new' },
  data () {
    return {
      instructionDialog: false
    }
  },
  mounted () {

    this.$store.commit('user/requestOppreg/clearWorkloadForm')
    this.$store.commit('user/requestOppreg/resetRegistration')
    this.$store.commit('user/requestOppreg/clearOpportunityRecord')
    
    
    if (this.$route.query.id) {
      this.sfdcId = this.$route.query.id
      this.$store.commit('user/requestOppreg/setOppregStep', 'opportunity')
      this.$store.dispatch('user/requestOppreg/register', this.$route.query.id)
    }
  },
  computed: {
    ...mapState('user/requestOppreg', ['sfdcId', 'registering', 'oppregStep'])
  },
  methods: {
    ...mapActions({
      register: 'user/requestOppreg/register'
    }),
    // registerOpportunity() {
    //   this.register(this.sfdcId)
    // },
    // goBackToOppLanding(){
    //   this.$store.commit('user/requestOppreg/setOppregStep', 'verification')
    // },
    goBackToVerification(){
      this.$store.commit('user/requestOppreg/setOppregStep', 'verification')
     this.$store.commit('user/requestOppreg/clearWorkloadForm')
    },
    goBackToOppForm () {
      // this.$store.commit('user/requestAws/setExistingLanding', true)
      this.$store.commit('user/requestOppreg/setOppregStep', 'opportunity')
    },
    
    onOppregFormSubmit (record) {
      this.oppregformSubmit(record)
    },
    onLandingFormContinue () {
      this.$store.commit('user/requestOppreg/setOppregStep', 'opportunity')
      console.log('continue on parent method')
    },
    onGenerateId (type) {
      console.log('generating id' + type)
      this.$store.dispatch('user/requestOppreg/generateId', type)
    }
    
  }
}

</script>

<style lang="scss" scoped>
#oppreg-wrapper {
  h3 {
    margin-top: 10px;
  }
  .request-con{ margin-top: 35px}
  .contacts{ margin-top: 35px}
  .last-name{
    margin-top: 24px
  }
  .email{
    width: 50%
  }
  .phone {
    width: 50%;
  }
  .result{
    margin-top: 35px;
  }
  .nodisplay{ display: none }

  .header {
    background: #000;
    color: #fff;
    // padding: 10px 15px;
    // margin: 10px 10px;
    h4.opp-id {
      color: #f09000
    }
    .container {
      padding: 0;
    }
    .container span{
      font-style: 600;
      text-decoration: underline
    }
  }

  #register {
    background: #000;
    color: #fff;
    padding:25px 15px 0 15px;
    margin: 10px 10px;
    .container {
      padding: 0;
    }
    .container input {
      color: #fff;
    }
    .container button {
      margin: 1px 1px;
      padding: 14px 30px;
    }
  }

  #oppreg-form {
    .container {
      span.desc {
        font-weight: 600;
      }
    }
  }

  #oppreg-qa {
    header {
      background: #000;
      color: #fff;
      margin: 10px 10px;
      .container {
        padding: 0 25px;
      }

    }
    .qa-form {
      margin: 25px 10px;
      .v-btn-toggle{ margin:0 0 10px 0}
      .v-btn-toggle .v-btn{
        padding: 15px 25px;
        opacity: .7px;
      }
      .btn--qa{
        font-weight: bold !important;
      }
      .v-select--width{
        width: 100%;
      }
      span{
        &.workload-desc{
          font-weight:600
        }
      }
      div{
        &.qa-desc{
          font-style: italic;
          font-size: 14px;
        }
      }

      .input-symbol-dollar {
          position: relative;
          display: block;
        }
        .input-symbol-dollar:after {
            color: #37424a !important;
            content: "$";
            font-size: 16px !important;
            font-weight: 400;
            position: absolute;
            display: block;
            height: 100%;
            top: 0;
            left: 10px;
            line-height: 42px;
        }
        .padding-left-15.v-text-field input{
          padding-left:15px;
          background: yellow;
        }

        .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
          background-color: grey;
        }
    }
      .opp-btn {
          width: 200px;
        }

  }
}
</style>
